import { useEffect, useState } from "react";
import Modal, { Styles } from "react-modal";
import { useNavigate, useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { ReactComponent as LeftArrow } from "../../../Assets/common/images/leftArrow.svg";
import {
  changeActiveComponent,
  changeUserInfo,
  changeUserRoles,
  createRoleProfile,
  deleteUser,
  emptyGeneratedPassword,
  getAllUsers,
  getOtherUser,
  getRoleOptions,
  getRoleProfiles,
  resetOtherUserData,
  resetRoleProfiledata,
  restorePassword,
  selectActiveConfigurationComponent,
  selectAllUsers,
  selectChangeRolesError,
  selectChangeRolesLoading,
  selectChangeUserInfoError,
  selectChangeUserInfoLoading,
  selectCurrentRoles,
  selectDeleteLoading,
  selectDeleteUserError,
  selectGeneratedPassword,
  selectLoadingOtherUser,
  selectOtherUser,
  selectRestorePasswordError,
  selectRestorePasswordLoading,
  selectRoleOptions,
  selectRoleOptionsLoading,
  selectRoleProfiles,
  selectRPCreationError,
  selectRPCreationLoading,
  setChangeRolesError,
  setChangeUserInfoError,
  setCurrentRoles,
  toggleUserStatus,
} from "../configurationSlice";
import { AccountView } from "./components/AccountView";
import { RolesComponent } from "./components/RolesComponent";
import { selectRoles } from "../../common/commonSlice";
import {
  getAsesores,
  selectAsesores,
} from "../../services/analytics/analyticsSlice";
import { ExpandibleContent } from "../../services/components/ExpandibleContent";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { ChangeUser, RoleProfile } from "../configurationAPI";
import { DropDown } from "../../common/components/Btns/DropDown";
import { formatDateStandar } from "../../../helpers/utils";
const customStylesModalRoles: Styles = {
  content: {
    top: "50%",
    left: "60%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(255,255,255,1)",
    borderRadius: "20px",
    boxSizing: "border-box",
    padding: "1.2%",
    width: "75%",
    overflow: "auto",
  },
  overlay: {
    background: "rgba(0,0,0,0.3)",
  },
};
const customStylesModalChangeInfo: Styles = {
  content: {
    top: "50%",
    left: "60%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(255,255,255,1)",
    borderRadius: "20px",
    boxSizing: "border-box",
    padding: "1.2%",
    width: "50%",
    overflow: "auto",
  },
  overlay: {
    background: "rgba(0,0,0,0.3)",
  },
};
Modal.setAppElement("#root");

export const UserDetail = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const loadingOtherUser = useAppSelector(selectLoadingOtherUser);
  const otherUser = useAppSelector(selectOtherUser);
  const roleProfiles = useAppSelector(selectRoleProfiles);
  const asesores = useAppSelector(selectAsesores);
  const activeComponent = useAppSelector(selectActiveConfigurationComponent);
  const roleOptionsLoading = useAppSelector(selectRoleOptionsLoading);
  const roleOptions = useAppSelector(selectRoleOptions);
  const rpCreationLoading = useAppSelector(selectRPCreationLoading);
  const rpCreationError = useAppSelector(selectRPCreationError);
  const currentRoles = useAppSelector(selectCurrentRoles);
  const generatedPassword = useAppSelector(selectGeneratedPassword);
  const restorePasswordLoading = useAppSelector(selectRestorePasswordLoading);
  const restorePasswordError = useAppSelector(selectRestorePasswordError);
  const changeRolesLoading = useAppSelector(selectChangeRolesLoading);
  const changeRolesError = useAppSelector(selectChangeRolesError);
  const changeInfoLoading = useAppSelector(selectChangeUserInfoLoading);
  const changeUserInfoError = useAppSelector(selectChangeUserInfoError);
  const deleteUserLoading = useAppSelector(selectDeleteLoading);
  const deleteUserError = useAppSelector(selectDeleteUserError);
  const roles = useAppSelector(selectRoles);
  const allUsers = useAppSelector(selectAllUsers);
  const { id } = useParams();

  // roles changing
  const [modalChangeRolesIsOpen, setModalChangeRolesIsOpen] = useState(false);
  const [rolesChangingType, setRolesChangingType] = useState<
    "SPECIFIC" | "ROLE_PROFILE" | "NONE"
  >();
  const [roleProfileCreate, setRoleProfileCreate] = useState(false);
  const [newRoleProfile, setNewRoleProfile] = useState<
    RoleProfile | undefined
  >();
  const [roleProfileIdAssigned, setRoleProfileIdAssigned] = useState<
    string | undefined
  >();
  // Change info
  const [modalChangeInfoIsOpen, setModalChangeInfoIsOpen] = useState(false);
  const [changeInfoError, setChangeInfoError] = useState<{
    nameError: string;
    phoneNumberError: string;
    identificationError: string;
  }>({
    nameError: "",
    phoneNumberError: "",
    identificationError: "",
  });
  const [changeInfoReq, setChangeInfoReq] = useState<{
    name: string;
    phoneNumber: string;
    identification: string;
    motive?: string;
    setAsesor?: boolean;
  }>({ name: "", phoneNumber: "", identification: "" });

  // Change password
  const [modalPasswordIsOpen, setModalPasswordIsOpen] = useState(false);
  const [isPersonalized, setIsPersonalized] = useState(false);
  const [personalizedPassword, setPersonalizedPassword] = useState<{
    password: string;
    passwordError?: string;
  }>({
    password: "",
  });
  const [copied, setCopied] = useState(false);
  // Delete
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  // show Change history
  const [modalChangeHistory, setModalChangeHistory] = useState(false);

  const canRestorePassword = () => {
    if (restorePasswordLoading === "pending") {
      return false;
    } else {
      if (isPersonalized) {
        if (personalizedPassword.password.length === 0) {
          return false;
        } else if (personalizedPassword.passwordError) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  };

  const changePasswordContent = () => {
    if (generatedPassword) {
      return (
        <div className="flex-col" style={{ alignItems: "center" }}>
          <div
            className="text-large text-bold"
            style={{ textAlign: "center", fontSize: "18px" }}
          >
            Restablecer Contraseña
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              margin: "10px 0 0 0",
            }}
          >
            <p
              style={{
                fontSize: "15px",
                color: "black",
                fontWeight: "500",
              }}
            >
              Se ha restablecido la contraseña del usuario con éxito
            </p>
            <div
              style={{
                border: "0.5px solid  rgba(0,0,0)",
                borderRadius: "8px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                padding: "5px 2px 5px 2px",
                margin: "4px 2px 10px 2px",
              }}
            >
              <h6
                style={{
                  margin: "0px 5px 0px 5px",
                  textAlign: "center",
                  fontSize: "22px",
                }}
              >
                {generatedPassword}
              </h6>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  try {
                    if (generatedPassword) {
                      navigator.clipboard.writeText(generatedPassword);
                      setCopied(true);
                    }
                  } catch {
                    setCopied(false);
                  }
                }}
                style={{
                  border: "none",
                  background: "transparent",
                  fontWeight: "700",
                }}
              >
                {copied ? "Copiado" : "Copiar"}
              </button>
            </div>
          </div>
          <div
            className="flex-row"
            style={{
              width: "90%",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: "15px",
            }}
          >
            <button
              onClick={(e) => {
                e.preventDefault();
                setIsPersonalized(false);
                setModalPasswordIsOpen(false);
                setPersonalizedPassword({ password: "" });
                dispatch(emptyGeneratedPassword());
              }}
              className="flex-col text-medium text-bold primary-color"
              style={{
                background: "#1A617D",
                width: "30%",
                height: "30px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "none",
              }}
            >
              Finalizar
            </button>
          </div>
        </div>
      );
    } else {
      return (
        <div className="flex-col" style={{ alignItems: "center" }}>
          <div
            className="text-large text-bold"
            style={{ textAlign: "center", fontSize: "18px" }}
          >
            Restablecer Contraseña
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              margin: "10px 0 0 0",
            }}
          >
            <p
              style={{
                fontSize: "15px",
                color: "black",
                fontWeight: "500",
                marginBottom: "0px",
              }}
            >
              Va a restablecer la contraseña de este usuario, la próxima vez que
              el usuario ingrese a la plataforma se le solicitará que establesca
              una nueva contraseña.
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "12px",
                marginBottom: "15px",
                width: "100%",
              }}
            >
              <FormControlLabel
                style={{
                  color: "#000",
                  width: "90%",
                  margin: "5px 0 5px 0px",
                  fontFamily: "Open Sans",
                }}
                control={
                  <Checkbox
                    style={{ color: "#000", alignSelf: "start" }}
                    checked={isPersonalized}
                    onChange={() => {
                      if (isPersonalized) {
                        setPersonalizedPassword({ password: "" });
                      }
                      setIsPersonalized((x) => !x);
                    }}
                  />
                }
                label={
                  <span
                    style={{
                      fontFamily: "Open Sans",
                      fontSize: "14px",
                      fontWeight: 600,
                    }}
                  >
                    ¿Ingresar una contraseña personalizada? (si no se ingresa,
                    se generara una aleatoria)
                  </span>
                }
              />
              {isPersonalized && (
                <label
                  htmlFor="passwordUser"
                  style={{
                    width: "60%",
                    marginRight: "10px",
                    alignSelf: "start",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "start",
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#000",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 2px",
                    }}
                  >
                    Contraseña
                  </p>
                  <input
                    onChange={(e) => {
                      if (e.target.value.length <= 8) {
                        setPersonalizedPassword({
                          ...personalizedPassword,
                          passwordError:
                            "La contrasena debe tener al menos 8 caracteres",
                          password: e.target.value,
                        });
                        setPersonalizedPassword({
                          ...personalizedPassword,
                          passwordError:
                            "La contrasena debe tener al menos 8 caracteres",
                          password: e.target.value,
                        });
                      } // password must contain a special character
                      else if (
                        !/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(
                          e.target.value
                        )
                      ) {
                        setPersonalizedPassword({
                          ...personalizedPassword,
                          passwordError:
                            "La contrasena debe contener por lo menos un caracter especial (!@#$%&*())",
                          password: e.target.value,
                        });
                      } // password must contain a number
                      else if (!/[0-9]/.test(e.target.value)) {
                        setPersonalizedPassword({
                          ...personalizedPassword,
                          passwordError:
                            "La contrasena debe contener por lo menos un número",
                          password: e.target.value,
                        });
                      } else {
                        setPersonalizedPassword({
                          ...personalizedPassword,
                          passwordError: "",
                          password: e.target.value,
                        });
                      }
                    }}
                    id="passwordUserMultiple"
                    name="passwordUserMultiple"
                    type="text"
                    placeholder="Contraseña segura"
                    value={personalizedPassword.password || ""}
                    style={{
                      border: "1px solid rgba(0,0,0,0.5)",
                      borderRadius: "6px",
                      background: "transparent",
                      padding: "8px 8px 8px 8px",
                      minHeight: "24px",
                      fontSize: "12px",
                      fontWeight: "500",
                      textAlign: "start",
                      color: "#000",
                      width: "100%",
                    }}
                  />
                  {personalizedPassword.passwordError && (
                    <p
                      style={{
                        fontSize: "11px",
                        textAlign: "start",
                        margin: "0 0 2px 2px",
                        fontWeight: "500",
                        color: "#cf4259",
                      }}
                    >
                      {personalizedPassword.passwordError}
                    </p>
                  )}
                </label>
              )}
            </div>
            {restorePasswordError && (
              <p
                style={{
                  color: "rgb(212, 0, 11)",
                  fontSize: "14px",
                  textAlign: "center",
                  fontWeight: "600",
                }}
              >
                {restorePasswordError}
              </p>
            )}
          </div>
          <div
            className="flex-row"
            style={{
              width: "90%",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: "15px",
            }}
          >
            <button
              onClick={(e) => {
                e.preventDefault();
                setIsPersonalized(false);
                setModalPasswordIsOpen(false);
                setPersonalizedPassword({ password: "" });
                dispatch(emptyGeneratedPassword());
              }}
              className="flex-col text-medium text-bold"
              style={{
                background: "transparent",
                width: "30%",
                height: "30px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "1px solid #1A617D",
                color: "#1A617D",
              }}
            >
              Cancelar
            </button>
            <button
              disabled={!canRestorePassword()}
              onClick={(e) => {
                e.preventDefault();
                dispatch(
                  restorePassword({
                    userId: otherUser?.id!,
                    newPassword:
                      personalizedPassword.password === ""
                        ? undefined
                        : personalizedPassword.password,
                  })
                );
              }}
              className="flex-col text-medium text-bold primary-color"
              style={{
                background: "#1A617D",
                width: "30%",
                height: "30px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "none",
              }}
            >
              {restorePasswordLoading === "pending" ? (
                <ClipLoader color="white" size={"20px"} />
              ) : (
                "Confirmar"
              )}
            </button>
          </div>
        </div>
      );
    }
  };

  const changeStatusTitle = () => {
    if (changeInfoLoading === "pending") {
      return <ClipLoader color={"#fff"} loading={true} size={25} />;
    } else {
      if (otherUser?.active) {
        return "Desactivar Usuario";
      } else {
        return "Activar Usuario";
      }
    }
  };

  const canFinishBasicInfo = () => {
    if (changeInfoReq.name.length === 0) {
      return false;
    }
    if (changeInfoError.nameError.length > 0) {
      return false;
    }
    if (changeInfoError.identificationError.length > 0) {
      return false;
    }
    if (changeInfoError.phoneNumberError.length > 0) {
      return false;
    }
    return true;
  };
  const roleListHaveSameRoles = (
    currentRoles?: string[],
    newRoles?: string[]
  ) => {
    if (currentRoles === undefined || newRoles === undefined) {
      return false;
    }
    if (currentRoles.length !== newRoles.length) {
      return false;
    }
    return currentRoles.every((role) => newRoles.includes(role));
  };
  const getRoleProfile = () => {
    if (otherUser && otherUser.roleProfileId && roleProfiles) {
      return roleProfiles.find(
        (roleProfile) => roleProfile.id === otherUser.roleProfileId
      );
    } else {
      return undefined;
    }
  };

  const getAsesor = () => {
    if (asesores) {
      return asesores.find((asesor) => asesor.id === otherUser?.id);
    }
  };

  const deleteUserContent = () => {
    return (
      <div className="flex-col" style={{ alignItems: "center" }}>
        <div
          className="text-large text-bold"
          style={{ textAlign: "center", fontSize: "18px" }}
        >
          Eliminar usuario
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            margin: "10px 0 0 0",
          }}
        >
          <p
            style={{
              fontSize: "15px",
              color: "black",
              fontWeight: "500",
            }}
          >
            ¿Estás seguro de eliminar a este usuario? <br />
            <span style={{ fontWeight: "bolder", fontSize: "11px" }}>
              (Si lo eliminas, no tendrá acceso a la plataforma y el nombre de
              usuario queda disponible para crear.) <br />
              (Esta acción no se puede revertir)
            </span>
          </p>
          {deleteUserError && (
            <p
              style={{
                color: "rgb(212, 0, 11)",
                fontSize: "14px",
                textAlign: "center",
                fontWeight: "600",
              }}
            >
              {deleteUserError}
            </p>
          )}
        </div>

        <div
          className="flex-row"
          style={{
            width: "90%",
            justifyContent: "space-evenly",
            alignItems: "center",
            marginTop: "15px",
          }}
        >
          <button
            onClick={(e) => {
              e.preventDefault();
              setModalConfirmDelete(false);
            }}
            className="flex-col text-medium text-bold"
            style={{
              background: "transparent",
              width: "30%",
              height: "30px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              border: "1px solid #1A617D",
              color: "#1A617D",
            }}
          >
            Cancelar
          </button>
          <button
            disabled={deleteUserLoading === "pending"}
            onClick={(e) => {
              e.preventDefault();
              dispatch(deleteUser(id!)).then((x) => {
                if (x.meta.requestStatus === "fulfilled") {
                  setModalConfirmDelete(false);
                  dispatch(resetOtherUserData());
                  navigate("/configuration/users");
                }
              });
            }}
            className="flex-col text-medium text-bold primary-color"
            style={{
              background: "#1A617D",
              width: "30%",
              height: "30px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              border: "none",
            }}
          >
            {deleteUserLoading === "pending" ? (
              <ClipLoader color="white" size={"20px"} />
            ) : (
              "Eliminar"
            )}
          </button>
        </div>
      </div>
    );
  };

  const getUserById = (userId: string) => {
    const user = allUsers.find((user) => user.id === userId);
    if (user) {
      return user.name;
    } else {
      return "";
    }
  };

  const changeData = (changeHistory?: ChangeUser) => {
    if (changeHistory) {
      const keys = Object.keys(changeHistory.dataUpdated);
      return (
        <div
          style={{
            width: "90%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "row",
            margin: "5px 0",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h6
              style={{
                fontSize: "10px",
                fontWeight: 600,
                color: "black",
              }}
            >
              Campo
            </h6>
            {keys.map((key, index) => {
              return (
                <h6
                  key={index}
                  style={{
                    color: "black",
                    fontSize: "10px",
                    fontWeight: "500",
                  }}
                >
                  {key}
                </h6>
              );
            })}
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h6
              style={{
                fontSize: "10px",
                fontWeight: 600,
                color: "black",
              }}
            >
              Antes del cambio
            </h6>
            {keys.map((key, index) => {
              return (
                <h6
                  key={index}
                  style={{
                    color: "black",
                    fontSize: "10px",
                    fontWeight: "500",
                  }}
                >
                  {changeHistory.currentData[key] || "-"}
                </h6>
              );
            })}
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h6
              style={{
                fontSize: "10px",
                fontWeight: 600,
                color: "black",
              }}
            >
              Después del cambio
            </h6>
            {keys.map((key, index) => {
              return (
                <h6
                  key={index}
                  style={{
                    color: "black",
                    fontSize: "10px",
                    fontWeight: "500",
                  }}
                >
                  {changeHistory.dataUpdated[key] || "-"}
                </h6>
              );
            })}
          </div>
        </div>
      );
    } else {
      return <h6>No hubo ningún cambio</h6>;
    }
  };

  const changeHistory = () => {
    if (otherUser?.changeHistory) {
      return (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            className="text-large text-bold"
            style={{
              textAlign: "center",
              fontSize: "18px",
              marginBottom: "15px",
            }}
          >
            Historial de cambios
          </div>
          <p
            style={{
              fontSize: "14px",
              color: "black",
              fontWeight: "500",
              textAlign: "center",
              margin: "0 0 2px 0",
            }}
          >
            Desde la creación de este usuario el{" "}
            {formatDateStandar(otherUser?.creationDate)} no han realizado{" "}
            {otherUser?.changeHistory.length} cambios, a continuación el detalle
            de cada uno.
          </p>
          <div
            style={{
              width: "100%",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gridGap: "10px",
              maxHeight: "350px",
              overflowY: "auto",
              alignItems: "center",
            }}
          >
            {otherUser?.changeHistory.map((change, index) => {
              return (
                <div
                  key={index}
                  style={{
                    border: "1px solid black",
                    borderRadius: "8px",
                    margin: "5px",
                    padding: "5px",
                    display: "flex",
                    flexDirection: "column",
                    width: "95%",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                      }}
                    >
                      <h6
                        style={{
                          fontSize: "10px",
                          fontWeight: 500,
                          color: "black",
                        }}
                      >
                        Modificado por:
                      </h6>
                      <p
                        style={{
                          fontSize: "12px",
                          fontWeight: 600,
                          color: "black",
                        }}
                      >
                        <a
                          href={`/configuration/users/${change.updatedById}`}
                          target="_blank"
                          rel="noreferrer"
                          style={{ color: "black" }}
                        >
                          {getUserById(change.updatedById!)}
                        </a>
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "end",
                      }}
                    >
                      <h6
                        style={{
                          fontSize: "10px",
                          fontWeight: 500,
                          color: "black",
                        }}
                      >
                        Fecha de modificación
                      </h6>
                      <p
                        style={{
                          fontSize: "12px",
                          fontWeight: 600,
                          color: "black",
                        }}
                      >
                        {formatDateStandar(change.updateDate)}
                      </p>
                    </div>
                  </div>
                  {changeData(change)}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <h6
                      style={{
                        fontSize: "10px",
                        fontWeight: 500,
                        color: "black",
                        margin: "1px 0",
                      }}
                    >
                      Descripción:
                    </h6>
                    <p
                      style={{
                        fontSize: "12px",
                        fontWeight: 600,
                        color: "black",
                        margin: 0,
                      }}
                    >
                      {change.description
                        ? change.description
                        : "Sin descripción"}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
          <div
            className="flex-row"
            style={{
              width: "80%",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: "15px",
              alignSelf: "center",
            }}
          >
            <button
              onClick={(e) => {
                e.preventDefault();
                setModalChangeHistory(false);
              }}
              className="flex-col text-medium text-bold"
              style={{
                background: "transparent",
                width: "50%",
                height: "30px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "1px solid #1A617D",
                color: "#1A617D",
              }}
            >
              Cerrar ventana
            </button>
          </div>
        </div>
      );
    } else {
      return (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            className="text-large text-bold"
            style={{
              textAlign: "center",
              fontSize: "18px",
              marginBottom: "15px",
            }}
          >
            Historial de cambios
          </div>
          <p
            style={{
              fontSize: "14px",
              color: "black",
              fontWeight: "500",
              textAlign: "center",
              margin: "0 0 2px 0",
            }}
          >
            Desde la creación de este usuario el{" "}
            {formatDateStandar(otherUser?.creationDate)} no se han realizado
            cambios a la información del usuario.
          </p>
          <div
            className="flex-row"
            style={{
              width: "80%",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: "15px",
              alignSelf: "center",
            }}
          >
            <button
              onClick={(e) => {
                e.preventDefault();
              }}
              className="flex-col text-medium text-bold"
              style={{
                background: "transparent",
                width: "50%",
                height: "30px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "1px solid #1A617D",
                color: "#1A617D",
              }}
            >
              Cerrar ventana
            </button>
          </div>
        </div>
      );
    }
  };

  const changeInfoContent = () => {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          className="text-large text-bold"
          style={{
            textAlign: "center",
            fontSize: "18px",
            marginBottom: "15px",
          }}
        >
          Cambiar Información Básica
        </div>
        <p
          style={{
            fontSize: "14px",
            color: "black",
            fontWeight: "500",
            textAlign: "center",
            margin: "0 0 2px 0",
          }}
        >
          Modifique los campos que requiera cambiar a continuación.
          <br />
          (los campos con "*" son obligatorios).
        </p>
        <div
          className="flex-col"
          style={{
            width: "100%",
            alignItems: "center",
            marginTop: "5px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "12px",
              width: "90%",
              alignSelf: "center",
            }}
          >
            <label
              htmlFor="nameUser"
              style={{
                width: "100%",
                marginRight: "10px",
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "start",
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: "500",
                  textAlign: "start",
                  margin: "0 0 2px 2px",
                }}
              >
                Nombre del usuario{" "}
                <span
                  style={{
                    color: "#cf4259",
                  }}
                >
                  *
                </span>
              </p>
              <input
                onChange={(e) => {
                  if (e.target.value.length > 40) {
                    setChangeInfoError({
                      ...changeInfoError,
                      nameError: "El nombre debe tener menos de 40 caracteres",
                    });
                  } else if (e.target.value.length === 0) {
                    setChangeInfoError({
                      ...changeInfoError,
                      nameError: "El nombre no puede estar vacío",
                    });
                  } else {
                    setChangeInfoError({
                      ...changeInfoError,
                      nameError: "",
                    });
                  }
                  setChangeInfoReq({
                    ...changeInfoReq,
                    name: e.target.value,
                  });
                }}
                id="nameUser"
                name="nameUser"
                type="text"
                placeholder="Nombre"
                value={changeInfoReq.name}
                style={{
                  border: "1px solid rgba(0,0,0,0.5)",
                  borderRadius: "6px",
                  background: "transparent",
                  padding: "8px 8px 8px 8px",
                  minHeight: "24px",
                  fontSize: "12px",
                  fontWeight: "500",
                  textAlign: "start",
                  color: "#000",
                  width: "100%",
                }}
              />
              {changeInfoError.nameError && (
                <p
                  style={{
                    fontSize: "11px",
                    textAlign: "start",
                    margin: "0 0 2px 2px",
                    fontWeight: "500",
                    color: "#cf4259",
                  }}
                >
                  {changeInfoError.nameError}
                </p>
              )}
            </label>
            <label
              htmlFor="identificationUser"
              style={{
                width: "100%",
                marginRight: "10px",
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "start",
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: "500",
                  textAlign: "start",
                  margin: "0 0 2px 2px",
                }}
              >
                Identificación
              </p>
              <input
                onChange={(e) => {
                  if (e.target.value.length > 20) {
                    setChangeInfoError({
                      ...changeInfoError,
                      identificationError:
                        "La identificación debe tener menos de 20 caracteres",
                    });
                  } else if (
                    e.target.value.length !== 0 &&
                    e.target.value.length < 8
                  ) {
                    setChangeInfoError({
                      ...changeInfoError,
                      identificationError:
                        "La identificación debe tener al menos 8 caracteres",
                    });
                  } else {
                    setChangeInfoError({
                      ...changeInfoError,
                      identificationError: "",
                    });
                  }
                  setChangeInfoReq({
                    ...changeInfoReq,
                    identification: e.target.value,
                  });
                }}
                id="identificatonUser"
                name="identificatonUser"
                type="text"
                placeholder="Opcional"
                value={changeInfoReq.identification}
                style={{
                  border: "1px solid rgba(0,0,0,0.5)",
                  borderRadius: "6px",
                  background: "transparent",
                  padding: "8px 8px 8px 8px",
                  minHeight: "24px",
                  fontSize: "12px",
                  fontWeight: "500",
                  textAlign: "start",
                  color: "#000",
                  width: "100%",
                }}
              />
              {changeInfoError.identificationError && (
                <p
                  style={{
                    fontSize: "11px",
                    textAlign: "start",
                    margin: "0 0 2px 2px",
                    fontWeight: "500",
                    color: "#cf4259",
                  }}
                >
                  {changeInfoError.identificationError}
                </p>
              )}
            </label>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "12px",
              width: "90%",
              alignSelf: "center",
            }}
          >
            <label
              htmlFor="phoneNumberUser"
              style={{
                width: "100%",
                marginRight: "10px",
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "start",
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: "500",
                  textAlign: "start",
                  margin: "0 0 2px 2px",
                }}
              >
                Número de Telefono
              </p>
              <input
                onChange={(e) => {
                  if (
                    e.target.value.length !== 0 &&
                    e.target.value.length < 8
                  ) {
                    setChangeInfoError({
                      ...changeInfoError,
                      phoneNumberError:
                        "El telefono debe tener al menos 8 caracteres",
                    });
                  } else if (e.target.value.length > 16) {
                    setChangeInfoError({
                      ...changeInfoError,
                      phoneNumberError:
                        "El telefono debe tener menos de 16 caracteres",
                    });
                  } else {
                    setChangeInfoError({
                      ...changeInfoError,
                      phoneNumberError: "",
                    });
                  }
                  setChangeInfoReq({
                    ...changeInfoReq,
                    phoneNumber: e.target.value,
                  });
                }}
                id="phoneNumberUser"
                name="phoneNumberUser"
                type="text"
                placeholder="Ej: 3112345678 (Opcional)"
                value={changeInfoReq.phoneNumber}
                style={{
                  border: "1px solid rgba(0,0,0,0.5)",
                  borderRadius: "6px",
                  background: "transparent",
                  padding: "8px 8px 8px 8px",
                  minHeight: "24px",
                  fontSize: "12px",
                  fontWeight: "500",
                  textAlign: "start",
                  color: "#000",
                  width: "100%",
                }}
              />
              {changeInfoError.phoneNumberError && (
                <p
                  style={{
                    fontSize: "11px",
                    textAlign: "start",
                    margin: "0 0 2px 2px",
                    fontWeight: "500",
                    color: "#cf4259",
                  }}
                >
                  {changeInfoError.phoneNumberError}
                </p>
              )}
            </label>
            <label
              htmlFor="motiveUser"
              style={{
                width: "100%",
                marginRight: "10px",
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "start",
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: "500",
                  textAlign: "start",
                  margin: "0 0 2px 2px",
                }}
              >
                Motivo de cambio
              </p>
              <input
                onChange={(e) => {
                  setChangeInfoReq({
                    ...changeInfoReq,
                    motive: e.target.value,
                  });
                }}
                id="motiveUser"
                name="motiveUser"
                type="text"
                placeholder="Opcional"
                value={changeInfoReq.motive}
                style={{
                  border: "1px solid rgba(0,0,0,0.5)",
                  borderRadius: "6px",
                  background: "transparent",
                  padding: "8px 8px 8px 8px",
                  minHeight: "24px",
                  fontSize: "12px",
                  fontWeight: "500",
                  textAlign: "start",
                  color: "#000",
                  width: "100%",
                }}
              />
            </label>
          </div>
          <FormControlLabel
            style={{
              color: "#000",
              width: "90%",
              margin: "5px 0 5px 0px",
              fontFamily: "Open Sans",
            }}
            control={
              <Checkbox
                style={{ color: "#000", alignSelf: "start" }}
                checked={changeInfoReq.setAsesor === true}
                onChange={() => {
                  let value = false;
                  if (changeInfoReq.setAsesor === true) {
                    value = false;
                  } else {
                    value = true;
                  }
                  setChangeInfoReq({
                    ...changeInfoReq,
                    setAsesor: value,
                  });
                }}
              />
            }
            label={
              <span
                style={{
                  fontFamily: "Open Sans",
                  fontSize: "14px",
                  fontWeight: 600,
                }}
              >
                Asignar como asesor
              </span>
            }
          />
          {changeUserInfoError && (
            <p
              style={{
                fontSize: "13px",
                color: "#cf4259",
                fontWeight: "500",
                textAlign: "center",
                marginTop: "10px",
                marginBottom: "5px",
              }}
            >
              {changeUserInfoError}
            </p>
          )}
        </div>
        <div
          className="flex-row"
          style={{
            width: "80%",
            justifyContent: "space-evenly",
            alignItems: "center",
            marginTop: "15px",
            alignSelf: "center",
          }}
        >
          <button
            onClick={(e) => {
              e.preventDefault();
              setChangeInfoReq({
                name: "",
                phoneNumber: "",
                identification: "",
                motive: undefined,
                setAsesor: undefined,
              });
              setChangeInfoError({
                nameError: "",
                identificationError: "",
                phoneNumberError: "",
              });
              dispatch(setChangeUserInfoError(undefined));
              setModalChangeInfoIsOpen(false);
            }}
            className="flex-col text-medium text-bold"
            style={{
              background: "transparent",
              width: "35%",
              height: "30px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              border: "1px solid #1A617D",
              color: "#1A617D",
            }}
          >
            Cancelar
          </button>
          <button
            disabled={!canFinishBasicInfo() || changeInfoLoading === "pending"}
            onClick={(e) => {
              e.preventDefault();
              dispatch(
                changeUserInfo({
                  userId: id!,
                  identification: changeInfoReq.identification,
                  name: changeInfoReq.name,
                  phoneNumber: changeInfoReq.phoneNumber,
                  motive: changeInfoReq.motive,
                  setAsesor: changeInfoReq.setAsesor,
                })
              ).then((x) => {
                if (x.meta.requestStatus === "fulfilled") {
                  setModalChangeInfoIsOpen(false);
                  setChangeInfoError({
                    nameError: "",
                    phoneNumberError: "",
                    identificationError: "",
                  });
                  setChangeInfoReq({
                    name: "",
                    phoneNumber: "",
                    identification: "",
                    motive: undefined,
                    setAsesor: undefined,
                  });
                }
              });
            }}
            className="flex-col text-medium text-bold primary-color"
            style={{
              background: "#1A617D",
              width: "35%",
              height: "30px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              border: "none",
            }}
          >
            {changeInfoLoading === "pending" ? (
              <ClipLoader color="white" size={"20px"} />
            ) : (
              "Confirmar cambios"
            )}
          </button>
        </div>
      </div>
    );
  };

  const roleProfileNameError = () => {
    if (newRoleProfile === undefined) {
      return "error";
    }
    roleProfiles.forEach((role) => {
      if (role.name === newRoleProfile.name) {
        return "Ya existe un rol con ese nombre";
      }
    });
    return "";
  };

  const roleProfileAssign = () => {
    if (roleOptionsLoading === "pending") {
      return <ClipLoader color={"#fff"} loading={true} size={35} />;
    } else {
      const options = roleProfiles.map((rp) => {
        return {
          label: rp.name!,
          value: rp.id!,
        };
      });
      return (
        <DropDown
          key={"roleProfile"}
          title=""
          maxContent
          options={options}
          onChange={(e) => {
            if (!e || e?.value === undefined) {
              setRoleProfileIdAssigned(undefined);
            }
            if (e?.value === "") {
              setRoleProfileIdAssigned(undefined);
            } else {
              setRoleProfileIdAssigned(e?.value);
            }
          }}
        />
      );
    }
  };

  const rolesChangeContent = () => {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          className="text-large text-bold"
          style={{
            textAlign: "center",
            fontSize: "18px",
            marginBottom: "15px",
          }}
        >
          Cambiar permisos
        </div>
        {roleProfiles && roleProfiles.length > 0 ? (
          <p
            style={{
              fontSize: "14px",
              color: "black",
              fontWeight: "500",
              textAlign: "center",
              margin: "0 0 15px 0",
            }}
          >
            A continuación, puedes asignar al usuario los permisos que va a
            tener en la plataforma.
            <br /> Puedes seleccionar un rol de permisos o permisos específicos
            para este usuario.
          </p>
        ) : (
          <p
            style={{
              fontSize: "14px",
              color: "black",
              fontWeight: "500",
              textAlign: "center",
              margin: "0 0 15px 0",
            }}
          >
            A continuación, debes asignar al usuario los permisos que va a tener
            el usuario en la plataforma.
          </p>
        )}
        {rpCreationError && (
          <p
            style={{
              fontSize: "13px",
              color: "#cf4259",
              fontWeight: "500",
              textAlign: "center",
            }}
          >
            {rpCreationError}
          </p>
        )}
        {changeRolesError && (
          <p
            style={{
              fontSize: "13px",
              color: "#cf4259",
              fontWeight: "500",
              textAlign: "center",
            }}
          >
            {changeRolesError}
          </p>
        )}

        <ExpandibleContent
          title={"Permisos específicos"}
          isActive={rolesChangingType === "SPECIFIC"}
          content={
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                padding: "0 10px 15px 10px",
                minHeight: "200px",
                overflowY: "auto",
              }}
            >
              <h5
                style={{
                  margin: "0px 0px 5px 0px",
                  color: "#fff",
                  fontSize: "17px",
                  fontWeight: "700",
                  textAlign: "start",
                }}
              >
                Permisos específicos
              </h5>
              <p
                style={{
                  margin: "0px 0px 15px 0px",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                Selecciona los permisos específicos que deseas asignar al
                usuario a continuación:
              </p>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <RolesComponent
                  width="70%"
                  immutableRoles={[]}
                  currentRoles={currentRoles}
                  predeterminedRoles={roleOptions}
                  loading={roleOptionsLoading}
                  visibility={"visible"}
                  darkMode
                  dontShowButtons
                />
                <div
                  className="flex-col"
                  style={{
                    width: "30%",
                    alignItems: "start",
                  }}
                >
                  {!roleListHaveSameRoles(currentRoles, otherUser?.roles) && (
                    <FormControlLabel
                      style={{
                        color: "#fff",
                        width: "90%",
                        margin: "5px 0 5px 0px",
                        fontFamily: "Open Sans",
                      }}
                      control={
                        <Checkbox
                          style={{ color: "#fff", alignSelf: "start" }}
                          checked={roleProfileCreate}
                          onChange={() => {
                            if (!roleProfileCreate) {
                              setNewRoleProfile({
                                clientId: "",
                                description: "",
                                name: "",
                                roles: [],
                              });
                            } else {
                              setNewRoleProfile(undefined);
                            }

                            setRoleProfileCreate((prev) => !prev);
                          }}
                        />
                      }
                      label={
                        <span
                          style={{
                            fontFamily: "Open Sans",
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#fff",
                          }}
                        >
                          ¿Guardar como rol de permisos?
                        </span>
                      }
                    />
                  )}
                  {currentRoles.length > 0 && roleProfileCreate && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "12px",
                        width: "80%",
                        alignSelf: "center",
                      }}
                    >
                      <label
                        htmlFor="name"
                        style={{
                          width: "100%",
                          marginRight: "10px",
                          alignSelf: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "start",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "13px",
                            color: "#fff",
                            fontWeight: "500",
                            textAlign: "start",
                            margin: "0 0 2px 2px",
                          }}
                        >
                          Nombre
                        </p>
                        <input
                          onChange={(e) => {
                            setNewRoleProfile({
                              ...newRoleProfile!,
                              name: e.target.value || "",
                            });
                          }}
                          id="name"
                          name="name"
                          type="text"
                          placeholder="Nombre del rol"
                          value={newRoleProfile?.name || ""}
                          style={{
                            border: "1px solid rgba(255,255,255,0.5)",
                            borderRadius: "6px",
                            background: "transparent",
                            padding: "8px 8px 8px 8px",
                            minHeight: "24px",
                            fontSize: "12px",
                            fontWeight: "500",
                            textAlign: "start",
                            color: "#fff",
                            width: "100%",
                          }}
                        />
                      </label>
                      {roleProfileNameError() && (
                        <p
                          style={{
                            fontSize: "11px",
                            textAlign: "start",
                            margin: "0 0 2px 2px",
                            fontWeight: "500",
                            color: "#cf4259",
                          }}
                        >
                          {roleProfileNameError()}
                        </p>
                      )}
                    </div>
                  )}
                  {currentRoles.length > 0 && roleProfileCreate && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: "15px",
                        marginTop: "5px",
                        width: "83%",
                        alignSelf: "center",
                      }}
                    >
                      <label
                        htmlFor="descripcion"
                        style={{
                          width: "100%",
                          marginRight: "10px",
                          alignSelf: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "start",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "13px",
                            color: "#fff",
                            fontWeight: "500",
                            textAlign: "start",
                            margin: "0 0 2px 2px",
                          }}
                        >
                          Descripción
                        </p>
                        <input
                          onChange={(e) => {
                            setNewRoleProfile({
                              ...newRoleProfile!,
                              description: e.target.value || "",
                            });
                          }}
                          id="descripcion"
                          name="descripcion"
                          type="text"
                          placeholder="Opcional"
                          value={newRoleProfile?.description || ""}
                          style={{
                            border: "1px solid rgba(255,255,255,0.5)",
                            borderRadius: "6px",
                            background: "transparent",
                            padding: "8px 8px 8px 8px",
                            minHeight: "24px",
                            fontSize: "12px",
                            fontWeight: "500",
                            textAlign: "start",
                            color: "#fff",
                            width: "100%",
                          }}
                        />
                      </label>
                    </div>
                  )}
                </div>
              </div>
            </div>
          }
          barColor="#1A617D"
          contentColor="rgb(61, 105, 122)"
          onClickFunction={() => {
            if (rolesChangingType === "SPECIFIC") {
              setRolesChangingType("NONE");
            }
            setRolesChangingType("SPECIFIC");
          }}
        />
        {roleProfiles && roleProfiles.length > 0 && (
          <ExpandibleContent
            title={"Rol"}
            isActive={rolesChangingType === "ROLE_PROFILE"}
            content={
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  padding: "0 10px 15px 10px",
                  minHeight: "200px",
                }}
              >
                <h5
                  style={{
                    margin: "0px",
                    color: "#fff",
                    fontSize: "17px",
                    fontWeight: "700",
                    textAlign: "start",
                  }}
                >
                  Roles
                </h5>
                <p
                  style={{
                    margin: "0px",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  Selecciona un rol de permisos predefinido para este usuario.
                </p>
                {roleProfileAssign()}
              </div>
            }
            barColor="#1A617D"
            contentColor="rgb(29, 72, 89)"
            onClickFunction={() => {
              if (rolesChangingType === "ROLE_PROFILE") {
                setRolesChangingType("NONE");
              }
              setRolesChangingType("ROLE_PROFILE");
            }}
          />
        )}
        <div
          className="flex-row"
          style={{
            width: "80%",
            justifyContent: "space-evenly",
            alignItems: "center",
            marginTop: "10px",
            alignSelf: "center",
          }}
        >
          <button
            onClick={(e) => {
              e.preventDefault();
              setModalChangeRolesIsOpen(false);
              setRolesChangingType("NONE");
              dispatch(resetRoleProfiledata());
              dispatch(setChangeRolesError(undefined));
              setRoleProfileIdAssigned(undefined);
              dispatch(emptyGeneratedPassword());
            }}
            className="flex-col text-medium text-bold"
            style={{
              background: "transparent",
              width: "35%",
              height: "30px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              border: "1px solid #1A617D",
              color: "#1A617D",
            }}
          >
            Cancelar
          </button>
          <button
            disabled={changeRolesLoading === "pending"}
            onClick={(e) => {
              e.preventDefault();
              if (currentRoles.length > 0 && roleProfileCreate) {
                dispatch(createRoleProfile(newRoleProfile!)).then((x) => {
                  if (x.meta.requestStatus === "fulfilled") {
                    let payload = x.payload as RoleProfile;
                    setNewRoleProfile(undefined);
                    dispatch(getRoleProfiles());
                    setRoleProfileCreate(false);
                    dispatch(
                      changeUserRoles({
                        userId: id!,
                        roleProfileId: payload.id!,
                      })
                    ).then((x) => {
                      if (x.meta.requestStatus === "fulfilled") {
                        setRolesChangingType("NONE");
                        dispatch(resetRoleProfiledata());
                        setModalChangeRolesIsOpen(false);
                        setRoleProfileIdAssigned(undefined);
                      }
                    });
                  }
                });
              } else {
                dispatch(
                  changeUserRoles({
                    userId: id!,
                    roleProfileId: roleProfileIdAssigned,
                  })
                ).then((x) => {
                  if (x.meta.requestStatus === "fulfilled") {
                    setRolesChangingType("NONE");
                    setModalChangeRolesIsOpen(false);
                    setRoleProfileIdAssigned(undefined);
                    dispatch(resetRoleProfiledata());
                  }
                });
              }
            }}
            className="flex-col text-medium text-bold primary-color"
            style={{
              background: "#1A617D",
              width: "35%",
              height: "30px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              border: "none",
            }}
          >
            {changeRolesLoading === "pending" ||
            rpCreationLoading === "pending" ? (
              <ClipLoader color="white" size={"20px"} />
            ) : (
              "Confirmar"
            )}
          </button>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (activeComponent !== "User") {
      dispatch(changeActiveComponent("User"));
    }
    dispatch(getOtherUser(id || ""));
    dispatch(getRoleOptions());
    dispatch(getRoleProfiles());
    if (allUsers.length === 0) {
      dispatch(getAllUsers());
    }
  }, []);

  useEffect(() => {
    if (otherUser?.esAsesor) {
      dispatch(getAsesores());
    }
  }, [otherUser]);

  if (loadingOtherUser === "pending") {
    return (
      <div
        style={{
          width: "100%",
          height: "90%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "1%",
        }}
      >
        <ClipLoader color="#FFF" size={"200px"} />
      </div>
    );
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "90%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          padding: "1%",
        }}
      >
        <Modal
          shouldCloseOnEsc
          shouldCloseOnOverlayClick
          shouldFocusAfterRender
          shouldReturnFocusAfterClose
          style={customStylesModalRoles}
          isOpen={modalChangeRolesIsOpen}
          onRequestClose={() => {
            setModalChangeRolesIsOpen(false);
            setRolesChangingType("NONE");
            dispatch(setChangeRolesError(undefined));
            dispatch(resetRoleProfiledata());
            dispatch(emptyGeneratedPassword());
            setRoleProfileIdAssigned(undefined);
          }}
        >
          {rolesChangeContent()}
        </Modal>
        <Modal
          shouldCloseOnEsc
          shouldCloseOnOverlayClick
          shouldFocusAfterRender
          shouldReturnFocusAfterClose
          style={customStylesModalChangeInfo}
          isOpen={modalChangeInfoIsOpen}
          onRequestClose={() => {
            setChangeInfoReq({
              name: "",
              phoneNumber: "",
              identification: "",
              motive: undefined,
              setAsesor: undefined,
            });
            setChangeInfoError({
              nameError: "",
              identificationError: "",
              phoneNumberError: "",
            });
            dispatch(setChangeUserInfoError(undefined));
            setModalChangeInfoIsOpen(false);
          }}
        >
          {changeInfoContent()}
        </Modal>
        <Modal
          shouldCloseOnEsc
          shouldCloseOnOverlayClick
          shouldFocusAfterRender
          shouldReturnFocusAfterClose
          style={customStylesModalChangeInfo}
          isOpen={modalChangeHistory}
          onRequestClose={() => {
            setModalChangeHistory(false);
          }}
        >
          {changeHistory()}
        </Modal>
        <Modal
          shouldCloseOnEsc
          shouldCloseOnOverlayClick
          shouldFocusAfterRender
          shouldReturnFocusAfterClose
          style={customStylesModalChangeInfo}
          isOpen={modalConfirmDelete}
          onRequestClose={() => {
            setModalConfirmDelete(false);
          }}
        >
          {deleteUserContent()}
        </Modal>
        <Modal
          shouldCloseOnEsc
          shouldCloseOnOverlayClick
          shouldFocusAfterRender
          shouldReturnFocusAfterClose
          style={customStylesModalChangeInfo}
          isOpen={modalPasswordIsOpen}
          onRequestClose={() => {
            dispatch(emptyGeneratedPassword());
            setModalPasswordIsOpen(false);
          }}
        >
          {changePasswordContent()}
        </Modal>
        <div
          onClick={(e) => {
            e.preventDefault();
            navigate(-1);
          }}
          className="flex-row"
          style={{
            alignItems: "center",
            justifyContent: "start",
            marginBottom: "1%",
            marginRight: "1%",
            alignSelf: "end",
            cursor: "pointer",
          }}
        >
          <LeftArrow style={{ marginRight: "15px" }} />
          <div className="text-bold text-x-large primary-color">
            Regresar a lista de usuarios
          </div>
        </div>
        {otherUser ? (
          <div
            style={{
              width: "99.5%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: "1%",
              }}
            >
              <div
                style={{
                  width: "49%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "start",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "start",
                    margin: "0 0 2% 0",
                  }}
                >
                  {(roles.includes("users.delete") ||
                    roles.includes("users.admin")) && (
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setModalConfirmDelete(true);
                      }}
                      style={{
                        border: "none",
                        background: "rgba(0,0,0,0.2)",
                        borderRadius: "8px",
                        padding: "12px 8px 12px 8px",
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#FFF",
                        marginRight: "2%",
                      }}
                    >
                      Eliminar usuario
                    </button>
                  )}
                  {roles.includes("users.edit") && (
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(toggleUserStatus(id!));
                      }}
                      style={{
                        border: "none",
                        background: "rgba(0,0,0,0.2)",
                        borderRadius: "8px",
                        padding: "12px 8px 12px 8px",
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#FFF",
                        marginRight: "2%",
                      }}
                    >
                      {changeStatusTitle()}
                    </button>
                  )}
                  {(roles.includes("users.edit") ||
                    roles.includes("users.admin")) && (
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setModalPasswordIsOpen(true);
                      }}
                      style={{
                        border: "none",
                        background: "rgba(0,0,0,0.2)",
                        borderRadius: "8px",
                        padding: "12px 8px 12px 8px",
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#FFF",
                        marginRight: "2%",
                      }}
                    >
                      Restablecer contraseña
                    </button>
                  )}
                </div>
                <AccountView
                  accountData={otherUser}
                  width="100%"
                  loading={loadingOtherUser}
                  roleProfile={getRoleProfile()}
                  asesorInfo={getAsesor()}
                  changeHistoryFunction={() => {
                    setModalChangeHistory(true);
                  }}
                  changeInfoFunction={() => {
                    setModalChangeInfoIsOpen(true);
                    setChangeInfoReq({
                      name: otherUser.name,
                      phoneNumber: otherUser.phoneNumber,
                      identification: otherUser.identification,
                      motive: undefined,
                      setAsesor: otherUser.esAsesor,
                    });
                  }}
                />
              </div>
              <RolesComponent
                changeRolesFunction={() => {
                  dispatch(setCurrentRoles(otherUser.roles));
                  setModalChangeRolesIsOpen(true);
                }}
                width="49%"
                currentRoles={otherUser.roles}
                immutableRoles={otherUser.roles}
                predeterminedRoles={roleOptions}
                loading={roleOptionsLoading}
                disabled={true}
                roleProfile={getRoleProfile()}
                visibility={
                  roles.includes("users.edit") || roles.includes("users.admin")
                    ? "visible"
                    : "hidden"
                }
              />
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <h4 style={{ color: "#FFF" }}>No existe el usuario</h4>
          </div>
        )}
      </div>
    );
  }
};
